export const CORPORATE_PARTICIPANT = 'CorporateParticipant'
